import { render, staticRenderFns } from "./CommentCreateField.vue?vue&type=template&id=34fcc84e&"
import script from "./CommentCreateField.vue?vue&type=script&lang=ts&"
export * from "./CommentCreateField.vue?vue&type=script&lang=ts&"
import style0 from "./CommentCreateField.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VFadeTransition,VIcon,VImg,VProgressCircular,VTextField})
